import { Component } from '@angular/core';

@Component({
  selector: 'app-navigation-tabs',
  templateUrl: './navigation-tabs.component.html'
})
export class NavigationTabsComponent {}
